import styles from './Logo.module.css'
const Logo = ({height}) => {
  return (
    <div className={styles.logo} style={{height:`${height}px`,width:`${parseInt(height*460/400)}px`}}></div>
  )
}

export default Logo
